import { LegacyDevice } from 'console/device/device';
import { Capability } from '../device/device-capability';
import { play_ztc_status_audio } from './ztc-status-audio';
import { selectDevice } from 'entities/device/lib';
//Эти функции должны жить в отдельном файле, иначе циклические ссылки
/**
 Переставляет `-` в `_` IO
 В стейте хранится с подчеркиванием, а приходит с тире
 * @param port_name
 */
function replacer(port_name) {
    return port_name.replace(/-/g, '_');
}
export const applyIOPorts = (dev_id_2_ports) => {
    const devid2setter = {};
    for (const [device_id, ports] of Object.entries(dev_id_2_ports)) {
        const setter = devid2setter[+device_id] ?? {};
        for (const [portname, { value }] of Object.entries(ports ?? {})) {
            setter[replacer(portname)] = value;
        }
    }
    return { type: 'APPLY_IO_PORTS', devid2setter };
};
export const setIOValue = (device_id, portname, portvalue) => (dispatch, getState) => {
    const device = selectDevice(getState(), device_id);
    if (device != null &&
        LegacyDevice.has_any_capability(device?.capabilities, [
            Capability.has_car_sensors,
            Capability.has_car_controls,
        ]) &&
        //@ts-ignore
        device[replacer(portname)] !== portvalue) {
        const settings = getState().ui_settings?.device_state_sounds?.[device_id]?.app_sounds;
        // В этом месте мы расчитываем,
        // что к нам сначала приходят все состояния девайса,
        // а только потом состояние, что девайс онлайн
        if (!(getState().app_settings?.settings?.widget_device_ids || []).includes(device_id) &&
            device.online)
            play_ztc_status_audio(device_id, portname, portvalue, settings);
    }
    const devid2setter = {};
    devid2setter[device_id] = {};
    devid2setter[device_id][portname.replace(/-/g, '_')] = portvalue;
    dispatch({ type: 'APPLY_IO_PORTS', devid2setter });
};
